<template>
    <section slot="pdf-content" class="pdf-content">
            <!-- PDF Content Here -->
             <section  v-for="(classementPaginationItem, indexPagination) in classement">
             <section class="pdf-item" > 
                
                <pdf-entete 
                  :club="club" 
                  :tournoi="tournoi" 
                  :indexPagination="indexPagination"
                  :classement="classement"
                  :date="today()"
                  :mode="mode"
                />
               <div style="text-align:center;width:100%;margin-top: 0px">
                <div v-for="(classement_item, indexClassement) in classementPaginationItem" class="lignePdf">
                    <div v-show="mode==0" v-if="typeof(classement_item)=='undefined'">
                          <b>{{classement_item.rang + 1}}</b>
                    </div>
                    <div v-show="mode==0" v-if="typeof(classement_item)!='undefined'">
                          <b>{{classement_item.classement}}</b>
                    </div>
                    <div class="nom" v-show="mode==0">
                          {{classement_item.numero+1}} - {{classement_item.captain}} 
                    </div>
                    <div class="nomListJoueur" v-show="mode==1">
                          {{classement_item.captain}} 
                    </div>
                     <div v-show="mode==1">
                          {{classement_item.numero+1}}
                    </div>
                    <div>
                      {{classement_item.nbPartieGagne}}
                    </div>
                    <div class="goal">
                        {{classement_item.diff}}
                    </div>
                    <div  class="goalParties" >
                        <span v-for="(index) in nbParties">
                        {{classement_item.partieScore[index-1]}}&nbsp;
                        </span>

                          
                    </div>
                </div>
               </div>
              </span>
            </section>
            <div class="html2pdf__page-break" v-if="indexPagination < classement.length-1"/>
             </section>
    </section>
</template>
<script>

import pdfEntete from '@/views/tournoi/export/pdfEnteteResultat.vue'
export default {
   props: ["club", "classement", "nbParties", "tournoi", "mode", "title"],
   components: {
     pdfEntete
   },
   methods: {
      today() {
       var today = new Date();

      const options = {  year: 'numeric', month: 'numeric', day: 'numeric', hour:'numeric', minute: 'numeric' };
      
       return today.toLocaleDateString(undefined, options);
     },
   },
   data() {
     return {
       classementPagination: []
     }
   }
   
}
</script>

<style lang="scss" scoped>

  .numberPage {
    float: right;
    margin-top: -20px;
    margin-right: 20px;
    font-size: 14px;
  }
  .today {
    font-style: italic;
    font-size: 12px;
    margin-top: -10px;
    margin-bottom: 10px;
  }
   .hearderBlock {
    
    color: black;
    font-size: 20px;
    font-weight: bolder;
  }
  
  .cartoucheClub {
    color: var(--bluebg);
    font-weight: bolder;
    height: 50px;
    margin-top: -50px;
  }
  .cartoucheTournoi {
    color: black;
    font-weight: bolder;
  }
  .image-container {
      width: 80px;
      height: 80px;
      overflow: hidden;
      position: relative;
      margin-right: 25px;
       border: inline black solid;
    }
      .image-containerLogo {
      width: 100px;
     
      overflow: hidden;
      position: relative;
      margin-right: 25px;
      text-align: right;
       border: inline black solid;
    }
    .headerResultat {
      font-size: 20x;
      font-weight: bolder;
    }
    .linkClub {
      font-size: 15px;
      color: var(--bluebg);
    }
    .linkClub  a {
      font-size: 15px;
      color: var(--bluebg);
      font-weight: bolder;
    }
  .pdf-content {
    margin-top: 40px;
  }
  
 
   
  .lignePdf div.goal {
    width: 120px;
  } 
  .lignePdf div {
    display: inline-block;
    width: 75px;
    text-align:center;
    color: black;
    
  }

  .lignePdf div.nom {
    display: inline-block;
    width: 250px;
    text-align:center;
     color: black;
     font-weight: bolder;
  }
    .lignePdf div.nomListJoueur {
    display: inline-block;
    width: 250px;
    text-align:left;
     color: black;
     font-weight: bolder;
  }
  
   .user-image {
        width: 100%;
        border: inline black solid;
    }
  .lignePdf div.goalParties {
    width: 200px;
    
  }
  .pdf-item {
    
  }
 
    
  

</style>